import React, {
  FC, useEffect, useState,
} from 'react';
import { QRCodeSVG } from 'qrcode.react';
import {
} from './Styles';
import Header from '../../Common/Header';
import Logo from '../../Common/Logo';
import { ColumnCenter } from '../Styles';
import { Ads3pdVO, Cab, Order, User } from '../../../../lib/types';
import { getFoodifoxDataLazy, updateFoodifoxData } from '../../../../lib/axios/FoodifoxDataAPI';
import SquadRegularText from '../../../../components/Text/SquadRegularText';
import SquadBoldText from '../../../../components/Text/SquadBoldText';
import PingFangRegularText from '../../../../components/Text/PingFangRegularText';
import PingFangSemiBoldText from '../../../../components/Text/PingFangSemiBoldText';
import SquadSemiBoldText from '../../../../components/Text/SquadSemiBoldText';
import PingFangMediumText from '../../../../components/Text/PingFangMediumText';
import { getCabId32Str } from '../../../../lib/utils/utils';
import Button from '../../../../components/Button';
import BackgroundImage from '../../../../components/BackgroundImage';
import AiModal from '../../Common/AiModal';
import AdsModal from '../../Common/AdsModal';
import Support from '../../Support';

const QRCode: FC<Props> = ({
  order,
  cab,
  user,
  isEnglish,
  setIsEnglish,
  setIsOpenSuccess,
  isShowAds,
  adsList,
  setAdsList,
  showAdsSeconds,
  skipAdsSeconds,
  isDarkMode,
}) => {
  // AI对话验证的手机号，每次进入都需要验证
  const [aiPhoneNumber, setAiPhoneNumber] = useState<string>();
  const [showSupportPage, setShowSupportPage] = useState<boolean>(false);
  const [showAiPage, setShowAiPage] = useState<boolean>(false);
  const [saveCallLog] = updateFoodifoxData('/foxH5RentLog/saveCallServiceLog');
  const [checkOrder] = getFoodifoxDataLazy<{ order: Order; cab: Cab }>('/foxH5Check/checkRentPickupSuccess?fetchCode=' + order.fetchCode);

  // 检查订单状态是否已完成
  const checkOrderStatus = () => {
    checkOrder({
      onError() {
        setTimeout(() => {
          checkOrderStatus();
        }, 1500);
      },
      onCompleted() {
        setIsOpenSuccess(true);
      },
    });
  };

  useEffect(() => {
    setTimeout(() => {
      checkOrderStatus();
    }, 1500);
  }, []);

  return (
    <>
      {
        !showAiPage && (
          <BackgroundImage backgroundImg={''}>
            <Header
              style={{ marginTop: '40px' }}
              isEnglish={isEnglish}
              setIsEnglish={setIsEnglish}
              setTargetPage={(targetPage) => {
                if (targetPage === 'support') {
                  setShowSupportPage(true);
                }
              }}
              showSupport={!!user?.deviceCode}
              showFAQ={true}
            />

            <Logo showBackIcon={false} style={{ marginTop: '30px' }} />

            {
              isEnglish ? (
                <>
                  <SquadRegularText fontSize={16} lineHeight={20} textAlign={'center'} marginTop={15}>
                    To collect your item and unlock the cubicle
                    <br />
                    please use the scanner on the locker and
                  </SquadRegularText>
                  <SquadBoldText fontSize={16} lineHeight={20} textAlign={'center'}>
                    scan the following QR code
                  </SquadBoldText>
                </>
              ) : (
                <>
                  <PingFangRegularText fontSize={16} lineHeight={22} textAlign={'center'} marginTop={18}>
                    要领取你的物品并打开柜门，
                    <br />
                    请使用储物柜上的扫描仪。
                  </PingFangRegularText>
                  <PingFangSemiBoldText fontSize={16} lineHeight={22} textAlign={'center'}>
                    扫描以下二维码。
                  </PingFangSemiBoldText>
                </>
              )
            }

            <ColumnCenter style={{ width: 261, borderRadius: 15, border: '1px solid rgba(17,32,43,0.1)', margin: '30px auto 0 auto' }}>
              {
                order && (
                  <>
                    {
                      isEnglish ? (
                        <SquadBoldText fontSize={18} marginTop={25}>
                          Door #{parseInt(order.boxNumber) < 10 ? `0${parseInt(order.boxNumber)}` : order.boxNumber}
                        </SquadBoldText>
                      ) : (
                        <PingFangSemiBoldText fontSize={18} marginTop={25}>
                          柜门 #{parseInt(order.boxNumber) < 10 ? `0${parseInt(order.boxNumber)}` : order.boxNumber}
                        </PingFangSemiBoldText>
                      )
                    }
                    {
                      // 需要显示广告时不显示二维码
                      !isShowAds && (
                        <QRCodeSVG
                          level={'H'}
                          value={order.fetchCode}
                          width={196}
                          height={196}
                          bgColor={'rgba(17,32,43,0.1)'}
                          style={{ marginTop: '12px', marginBottom: '20px' }}
                        />
                      )
                    }

                    {
                      isEnglish ? (
                        <>
                          <SquadRegularText lineHeight={18} isSpan={true} textAlign={'center'}>
                            For issues with the QR code please
                          </SquadRegularText>
                          <SquadSemiBoldText lineHeight={18} isSpan={true} marginLeft={5} textAlign={'center'}>
                            use the ‘Support’ button in the top left
                          </SquadSemiBoldText>
                          <SquadRegularText lineHeight={18} isSpan={true} marginLeft={5} textAlign={'center'}>
                            or call Foodifox support on:
                          </SquadRegularText>
                          <SquadBoldText lineHeight={18} textAlign={'center'}>
                            1300 359 889
                          </SquadBoldText>
                        </>
                      ) : (
                        <>
                          <PingFangRegularText lineHeight={21} isSpan={true} textAlign={'center'}>
                            如果二维码有问题，
                          </PingFangRegularText>
                          <PingFangMediumText lineHeight={21} isSpan={true} marginLeft={5} textAlign={'center'}>
                            请使用左上角的"支持"按钮
                          </PingFangMediumText>
                          <PingFangRegularText lineHeight={21} isSpan={true} marginLeft={5} textAlign={'center'}>
                            或拨打Foodifox支持电话：
                          </PingFangRegularText>
                          <SquadBoldText lineHeight={18} textAlign={'center'}>
                            1300 359 889
                          </SquadBoldText>
                        </>
                      )
                    }

                    <Button
                      width={111}
                      height={38}
                      borderRadius={27}
                      backgroundColor={'#11202B'}
                      marginTop={15}
                      marginBottom={25}
                      onClick={() => {
                        location.href = 'tel:1300359889';
                        saveCallLog({
                          param: {
                            cabId: getCabId32Str(cab.cabId),
                            telNumber: '1300359889',
                          },
                        });
                      }}
                    >
                      {
                        isEnglish ? (
                          <SquadBoldText color={'#FFFFFF'}>
                            Call now
                          </SquadBoldText>
                        ) : (
                          <PingFangSemiBoldText color={'#FFFFFF'}>
                            立即拨打
                          </PingFangSemiBoldText>
                        )
                      }
                    </Button>
                  </>
                )
              }
            </ColumnCenter>

            <div style={{ width: '100%', height: 45 }} />
          </BackgroundImage>
        )
      }

      {
        showSupportPage && user?.deviceCode && (
          <Support
            cab={cab}
            isEnglish={isEnglish}
            setIsEnglish={setIsEnglish}
            setShowAi={setShowAiPage}
            // AI对话验证的手机号，每次进入都需要验证
            setAiPhoneNumber={setAiPhoneNumber}
            setTargetPage={() => {
              setShowSupportPage(false);
            }}
          />
        )
      }
      {
        showAiPage && user?.deviceCode && aiPhoneNumber && (
          <AiModal
            setShowModal={setShowAiPage}
            setTargetPage={() => setShowAiPage(false)}
            isEnglish={isEnglish}
            setIsEnglish={setIsEnglish}
            cabId={cab.cabId}
            deviceCode={user.deviceCode}
            enterPhoneNumber={aiPhoneNumber}
          />
        )
      }

      {
        // 显示广告
        isShowAds && (
          <AdsModal
            onClose={() => setAdsList([])}
            isEnglish={isEnglish}
            adsList={adsList}
            showAdsSeconds={showAdsSeconds}
            deviceCode={user?.deviceCode || ''}
            phoneNumber={user?.phoneNumber}
            skipAdsSeconds={skipAdsSeconds}
          />
        )
      }
    </>
  );
};

export interface Props {
  order: Order;
  cab: Cab;
  user?: User;
  isEnglish: boolean;
  setIsEnglish: (isEng: boolean) => void;
  setIsOpenSuccess: (isOpenSuccess: boolean) => void;
  isShowAds: boolean;
  adsList: Ads3pdVO[];
  setAdsList: (adsList: Ads3pdVO[]) => void;
  showAdsSeconds: number;
  skipAdsSeconds: number;
  isDarkMode: boolean;
}

export default QRCode;
